import {Pipe, PipeTransform} from '@angular/core';

@Pipe({
    name: 'numerico'
})
export class NumberPipe implements PipeTransform {
    transform(value: number): string {
        var teste = value.toString();
        var numero = Number(teste);
        return numero.toFixed(2);
    }
}


// WEBPACK FOOTER //
// ./src/app/pipes/number-pipes.ts